export const parseRange = (rangeVal) => {
  if (!rangeVal) {
    return "";
  }

  const tmp = rangeVal.split("||").map((range) => {
    const values = range.split("|").map((value) => value?.trim());
    const firstValueParts = values[0].split("#");
    const firstValue = firstValueParts[0].trim();
    const firstUnit = firstValueParts[1] ? firstValueParts[1].trim() : "";

    const secondValueParts = values[1]
      ? values[1].split("#")
      : [undefined, undefined];
    const secondValue = secondValueParts[0] ? secondValueParts[0].trim() : "";
    const secondUnit = secondValueParts[1] ? secondValueParts[1].trim() : "";

    let result = "";

    if (firstValue) {
      result += `${firstValue}`;
    }

    if (firstValue && secondValue) {
      result += " to ";
    }

    if (secondValue) {
      result += `${secondValue}`;
    }
    if (firstUnit && secondUnit) {
      if (firstUnit === secondUnit) {
        result += ` ${firstUnit}`;
      } else {
        result = `${firstValue} ${firstUnit} to ${secondValue} ${secondUnit}`;
      }
    } else if (firstUnit) {
      result += ` ${firstUnit}`;
    } else if (secondUnit) {
      result += ` ${secondUnit}`;
    }

    return result;
  });

  return tmp.join(" , ");
};

export const parseDepth = (fromVal, toVal) => {
  // If both are missing, return empty string
  if (!fromVal && !toVal) {
    return "";
  }

  const fromParts = fromVal ? fromVal.split("#").map(part => part.trim()) : ["", ""];
  const toParts = toVal ? toVal.split("#").map(part => part.trim()) : ["", ""];

  const firstValue = fromParts[0];
  const firstUnit = fromParts[1];
  const secondValue = toParts[0];
  const secondUnit = toParts[1];

  let result = "";

  if (firstValue) {
    result += `${firstValue}`;
  }

  if (firstValue && secondValue) {
    result += " to ";
  }

  if (secondValue) {
    result += `${secondValue}`;
  }

  if (firstUnit && secondUnit) {
    if (firstUnit === secondUnit) {
      result += ` ${firstUnit}`;
    } else {
      result = `${firstValue} ${firstUnit} to ${secondValue} ${secondUnit}`;
    }
  } else if (firstUnit) {
    result += ` ${firstUnit}`;
  } else if (secondUnit) {
    result += ` ${secondUnit}`;
  }

  return result;
};
